module.exports = __webpack_public_path__ + "static/media/temp_chart5.9dab6efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/colonyGame/temp_chart5.png
// module id = 2283
// module chunks = 0